import { toPostLoginLocation } from './postLoginNavigation'

const POST_LOGIN_NEXT_KEY = 'orphex_post_login_next'

export function getSafePostAuthRedirect(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const target = value.trim()
  if (!target.startsWith('/')) return null
  const safeLocation = toPostLoginLocation(target)
  return typeof safeLocation === 'string' ? safeLocation : null
}

export function storePostLoginRedirect(value: string | null): void {
  if (typeof window === 'undefined') return
  if (value === null) {
    window.sessionStorage.removeItem(POST_LOGIN_NEXT_KEY)
    return
  }
  window.sessionStorage.setItem(POST_LOGIN_NEXT_KEY, value)
}

export function consumeStoredPostLoginRedirect(): string | null {
  if (typeof window === 'undefined') return null
  const target = window.sessionStorage.getItem(POST_LOGIN_NEXT_KEY)
  window.sessionStorage.removeItem(POST_LOGIN_NEXT_KEY)
  return getSafePostAuthRedirect(target)
}

export { toPostLoginLocation }
